import React, { useState, useEffect } from "react";
import "../../../Styles/Modal.css";
import "../../../Styles/reModal.css";
import { ImCancelCircle } from "react-icons/im";

const MVT = ({ handleMvtSelect, selMvt, handleMvtModal }: any) => {
  const [selectedMvt, setSelectedMvt] = useState("");
  const handleMvtClick = (type: any) => {
    setSelectedMvt(type);
    handleMvtSelect(type);
  };

  return (
    <div className="modal">
      <div className="catModal">
        <div className="catModalTop">
          <h4>Movement Type</h4>
          <ImCancelCircle className="catCancel" onClick={handleMvtModal} />
        </div>
        <div className="line"></div>
        <div className="cusmm">
          <p
            onClick={() => handleMvtClick("Self Collection")}
            className={`${selectedMvt === "Self Collection" ? "payT payDark" : "payT"}`}
          >
            Self Collection
          </p>
          <p
            onClick={() => handleMvtClick("Local Delivery")}
            className={`${selectedMvt === "Local Delivery" ? "payT payDark" : "payT"}`}
          >
            Local Delivery
          </p>
            <p
            onClick={() => handleMvtClick("Stock Delivery")}
            className={`${selectedMvt === "Stock Delivery" ? "payT payDark" : "payT"}`}
          >
            Stock Delivery
          </p>
            <p
            onClick={() => handleMvtClick("Others")}
            className={`${selectedMvt === "Others" ? "payT payDark" : "payT"}`}
          >
            Others
          </p>
        </div>

        <div className="catModalBtn">
          <button
            className={`${selMvt ? "catBtn1" : "opBtn"}`}
            onClick={handleMvtModal}
          >
            Select
          </button>
          <button className="catBtn2" onClick={handleMvtModal}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default MVT;
